//Styles
import Styles from "./Header.module.scss"
import classnames from "classnames";

//Component
import { ReactNode, useContext, useEffect, useState } from "react";
import { getDateTime } from "../../methods/getDateTime";
import ContextMenu from "../context-menu/ContextMenu";
import Menu from "../menu/Menu";

//Icons
import { ReactComponent as AppleIcon } from "../../icons/common/apple_logo.svg"
import { ReactComponent as BatteryIcon } from "../../icons/common/battery.svg"
import { ReactComponent as WifiIcon } from "../../icons/common/wifi.svg"
import { ReactComponent as SpotlightIcon } from "../../icons/common/spotlight.svg"
import { ReactComponent as ControlCenterIcon } from "../../icons/common/control_center.svg"
import { ReactComponent as SiriIcon } from "../../icons/common/siri.svg"



//Redux
import { openWindow } from "../../actions";
import { useDispatch } from "react-redux";
import { APP_KEY_IDS } from "../../constants/constants";
import Spotify from "../spotify/Spotify";
import ControlCenter from "../control-center/ControlCenter";
import Calendar from "../calendar/CalendarContainer";
import { signOut } from "firebase/auth";
import { auth } from "../../useFirebaseInit";
import { AuthContext } from "../../contexts/AuthContext";


const Header = () => {

    const {setUser} =useContext(AuthContext)

    const dispatch = useDispatch()

    const [currentTime, setTime] = useState(getDateTime())
    const [hover, setHover] = useState(-1)
    const [hoverItem, setHoverItem] = useState<string>("")


    const reload = () => {
        document.documentElement.style.setProperty(('--brightness'), '0');
        document.documentElement.style.setProperty(('--saturation'), '0');
        setTimeout(() => {
            window.location.reload();
        }, 3000);
    };

    const sleepEffect = ()=>{
        document.documentElement.style.setProperty(('--brightness'), '0');
    }

    const shutDown = () => {
        sleepEffect()
        setTimeout(()=>{
            window.location.href = 'https://www.google.com';
        },2000)
    };

    const handleLogout = () => {
        signOut(auth).then(() => {
            setUser({
                userName: "",
                userId: "",
                pfpUrl: "",
                email:"",
                isEmailVerified:""
              })
        }).catch((error) => {});
        dispatch(openWindow(APP_KEY_IDS.LOCK_SCREEN)) 
    }

    interface OptionType {
        id: string;
        component: any;
        subOptions?: OptionType[],
        isComponent?: boolean,
        onClick: () => void;
    }

    const leftHeaderMenu: OptionType[] = [
        {
            id: "apple",
            component: <AppleIcon />,
            subOptions: [
                {
                    id: "about",
                    component: "About This Mac",
                    onClick: () => { dispatch(openWindow(APP_KEY_IDS.ABOUT_SYSTEM)) }
                },
                {
                    id: "settings",
                    component: "System Settings",
                    onClick: () => { dispatch(openWindow(APP_KEY_IDS.SETTINGS)) }
                },
                {
                    id: "app_store",
                    component: "App Store",
                    onClick: () => { dispatch(openWindow(APP_KEY_IDS.APP_STORE)) }
                },
                {
                    id: "sleep",
                    component: "Sleep",
                    onClick: sleepEffect
                },
                {
                    id: "restart",
                    component: "Restart",
                    onClick: reload
                },
                {
                    id: "shut_down",
                    component: "Shut Down",
                    onClick: shutDown
                },
                {
                    id: "lock_screen",
                    component: "Lock Screen",
                    onClick: () => { dispatch(openWindow(APP_KEY_IDS.LOCK_SCREEN)) }
                },
                {
                    id: "log_out",
                    component: "Log Out",
                    onClick: handleLogout
                },
            ],
            onClick: () => { }
        },
        {
            id: "file",
            component: "File",
            onClick: () => { }
        },
        {
            id: "edit",
            component: "Edit",
            onClick: () => { }
        },
        {
            id: "view",
            component: "View",
            onClick: () => { }
        },
        {
            id: "window",
            component: "Window",
            onClick: () => { }
        },
        {
            id: "help",
            component: "Help",
            onClick: () => { dispatch(openWindow(APP_KEY_IDS.HELP)) }
        },

    ]


    const rightHeaderMenu: OptionType[] = [
        {
            id: "battery",
            component: <BatteryIcon />,
            onClick: () => { },
            subOptions: [
                {
                    id: "charging_status",
                    component: <div style={{ display: "flex", justifyContent: "space-between", gap: "8px", alignItems: "center" }}><BatteryIcon /> 90%-Charged</div>,
                    onClick: () => { }
                },
            ]
        },
        {
            id: "wifi",
            component: <WifiIcon />,
            onClick: () => { }
        },
        {
            id: "spotlight",
            component: <SpotlightIcon />,
            onClick: () => { dispatch(openWindow(APP_KEY_IDS.FINDER)) }
        },
        {
            id: "control_center",
            component: <ControlCenterIcon />,
            onClick: () => { },

            isComponent: true,
            subOptions: [
                {
                    id: "control_center_main",
                    isComponent: true,
                    component: <ControlCenter />,
                    onClick: () => { }
                },
            ]
        },
        {
            id: "siri",
            component: <SiriIcon />,
            onClick: () => { }
        },
        {
            id: "date",
            component: <div className={Styles.date}>{currentTime}</div>,
            isComponent: true,
            subOptions: [
                {
                    id: "control_center_main",
                    isComponent: true,
                    component: <Calendar />,
                    onClick: () => { }
                },
            ],
            onClick: () => { }
        },

    ]


    const handleMouseHover = (hoverId: string, menuType: number) => {
        setHover(menuType)
        setHoverItem(hoverId)
    }

    const handleMouseOut = () => {
        setHover(-1)
        setHoverItem("")
    }

    return (
        <div className={classnames(Styles.header)}>
            <div className={Styles.left_menu}>
                {
                    leftHeaderMenu.map((option: any, index: number) => {
                        return (
                            <div
                                key={option.id || option.label || index}
                                className={Styles.option}
                                onMouseOver={() => { handleMouseHover(option.id, 0) }}
                                onMouseOut={handleMouseOut}
                                onClick={option.onClick}>
                                {option.component}
                                {leftHeaderMenu[index].subOptions &&
                                    <div className={Styles.drop_down}>
                                        <Menu options={leftHeaderMenu[index].subOptions} isComponent={leftHeaderMenu[index].isComponent} />
                                    </div>
                                }
                            </div>
                        )
                    })
                }
            </div>
            <div className={Styles.right_menu}>
                {
                    rightHeaderMenu.map((option: any, index: number) => {
                        return (
                            <div
                                key={option.id || option.label || index}
                                className={Styles.option}
                                onMouseOver={() => { handleMouseHover(option.id, 1) }}
                                onMouseOut={handleMouseOut}
                                onClick={option.onClick}>
                                {option.component}

                                {rightHeaderMenu[index].subOptions &&
                                    <div className={Styles.drop_down}>
                                        <Menu options={rightHeaderMenu[index].subOptions} isComponent={rightHeaderMenu[index].isComponent} />
                                    </div>
                                }
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default Header


